import { defineMessages } from 'react-intl';

export default defineMessages({
	heading: {
		id: 'discountLanding.testimonials.heading',
		defaultMessage: 'Join millions of others finding Calm',
		description: 'Heading for testimonial section',
	},
	downloads: {
		id: 'discountLanding.testimonials.downloads',
		defaultMessage: '100M+ downloads',
		description: 'Number of times downloaded stat',
	},
	starRewards: {
		id: 'discountLanding.testimonials.starRewards',
		defaultMessage: '1.5M+ 5-star reviews',
		description: 'Number of five star ratings stat',
	},
	celeseTestimonial: {
		id: 'discountLanding.testimonials.celeseTestimonial',
		defaultMessage:
			'I continued on, and now I’ve been <boldtext>meditating for about three years.</boldtext> I feel like it’s <boldtext>helped me reduce the anxiety</boldtext> that was creating a lot of issues in my life before.',
		description: 'Testimonial from user Celeste',
	},
	celesteName: {
		id: 'discountLanding.testimonials.celesteName',
		defaultMessage: 'Celeste',
		description: 'The name "Celeste"',
	},
	celesteDate: {
		id: 'discountLanding.testimonials.celesteDate',
		defaultMessage: 'Calm member since 2017',
		description: 'How long Celeste has been a member of Calm',
	},
	jtTestimonial: {
		id: 'discountLanding.testimonials.jtTestimonial',
		defaultMessage:
			'As a runner, I believe that <boldtext>mental fitness is key</boldtext> and post run meditation sessions <boldtext>help me feel more grounded...</boldtext> Calm has helped me take my mindfulness practice to another level.',
		description: 'Testimonial from user JT',
	},
	jtName: {
		id: 'discountLanding.testimonials.jtName',
		defaultMessage: 'J.T.',
		description: 'The name "JT"',
	},
	jtDate: {
		id: 'discountLanding.testimonials.jtDate',
		defaultMessage: 'Calm member since 2019',
		description: 'How long JT has been a member of Calm',
	},
	alisonTestimonial: {
		id: 'discountLanding.testimonials.alisonTestimonial',
		defaultMessage:
			'Emotionally, I’m more resilient and I believe I have a <boldtext>better relationship with myself</boldtext>, a stronger sense of who I am, and I hold <boldtext>a lot less tension</boldtext> in my body.',
		description: 'Testimonial from user Alison',
	},
	alisonName: {
		id: 'discountLanding.testimonials.alisonName',
		defaultMessage: 'Alison',
		description: 'The name "Alison"',
	},
	alisonDate: {
		id: 'discountLanding.testimonials.alisonDate',
		defaultMessage: 'Calm member since 2014',
		description: 'How long Alison has been a member of Calm',
	},
	cta: {
		id: 'discountLanding.testimonials.cta',
		defaultMessage: 'Get Calm Premium',
		description: 'Button copy leading user to payment page',
	},
});
